import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    button: {
      alignSelf: "center",
      backgroundColor: "#009FB8",
      borderRadius: "4px",
      width: "178px", // Set the width to 100% to ensure it doesn't extend beyond the dialog
      height: "48px",
      marginTop: "30px"
    },
    buttonTitle: {
      fontSize: "18px",
      color: "white"
    },

    dialog: {
      width: "420px",
      padding: theme.spacing(4),
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      minHeight: "200px", // Set a min-height to prevent the dialog from collapsing
      overflowWrap: "break-word",
      justifyContent: "space-between"
    },

    titles: {
      color: "#222",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    messageBody: {
      color: "#222",
      fontFamily: "SCG",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      marginTop: "10px",
      marginRight: "5px"
    },
    body2: {
      color: "#009FB8",
      fontFamily: "SCG",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      marginTop: "10px"
    },
    contentBox: {
      background: "#F4F7FE",
      borderRadius: "4px",
      marginTop: "33px"
    },
    content: {
      color: "#222",
      fontFamily: "SCG",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "22px",
      margin: "10px 0 10px 10px"
    },
    subContent: {
      color: "#222",
      fontFamily: "SCG",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "22px",
      alignItems: "Right",
      margin: "10px 0 10px 0"
    },
    succcesType: {
      display: "flex",
      justifyContent: "Left",
      alignItems: "Left",
      marginTop: "5px"
    }
  }),
  { name: "DialogExcelUploadSuccess" }
);

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  messageBody: string;
  subContent: string;
}

const ExcelUploadSuccessDialogPopup = ({
  isOpen,
  onClose,
  messageBody,
  subContent
}: Props) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Box className={classes.dialog}>
        <div className={classes.succcesType}>
          <Typography className={classes.titles}>
            {intl.formatMessage({
              defaultMessage: "การอัพโหลดไฟล์สำเร็จ",
              description: "title"
            })}
          </Typography>
        </div>
        <div className={classes.messageBody}>
          <Typography component="span" className={classes.messageBody}>
            {intl.formatMessage(
              {
                defaultMessage: "{messageBody}",
                description: "messageBody"
              },
              { messageBody }
            )}
          </Typography>

          <Typography component="span" className={classes.body2}>
            {intl.formatMessage({
              defaultMessage: "กรุณารออีเมล์ยืนยันใบสั่งซื้อ",
              description: "subMessage"
            })}
          </Typography>
        </div>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className={classes.contentBox}
        >
          <Typography component="span" className={classes.content}>
            {intl.formatMessage({
              defaultMessage: "รายการที่อัพโหลดทั้งหมด",
              description: "content"
            })}
          </Typography>
          <Typography component="span" className={classes.subContent}>
            <span className={classes.subContent}>
              {intl.formatMessage(
                {
                  defaultMessage: "{subContent}",
                  description: "item counts"
                },
                { subContent }
              )}
            </span>
            <span className={classes.content} style={{ marginLeft: "5px" }}>
              {intl.formatMessage({
                defaultMessage: "รายการ",
                description: "items"
              })}
            </span>
          </Typography>
        </div>

        <Button className={classes.button} onClick={onClose}>
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage({
              defaultMessage: "ปิด",
              description: "Close"
            })}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default ExcelUploadSuccessDialogPopup;
